/**
 * Created by Justin Bernert on 14/12/2015.
 */

import { DoorNode } from "./DoorNode";
import { JoineryNode } from "../JoineryNode";
import { Utils } from "../../../utils/Utils";
import { PlanManager } from "../../../../../cocosPlan";
import { Door, SceneConstants } from "@rhinov/savane-js";

declare var cc: any;

export class FrontDoorNode extends DoorNode {
    constructor(jDoor: Door) {
        super(jDoor);
    }

    computeModel(joinery: Door) {
        if (joinery !== undefined) {
            this._nbDoors = joinery.nbDoors;
            this._openingMode = joinery.openingMode;
            this._slideDirection = joinery.slideDirection;
            this._handleSide = joinery.handleSide;
            this._openingSymetry = joinery.openingSymetry;
            this._orientation = joinery.orientation;
            this._length = joinery.length;
            if (joinery.wall != null)
                this._thickness = joinery.wall.thickness;
            else
                this._thickness = this._length / 10;

            this._wallInstallTye = joinery.wallInstallType;
        }

        var idealSize = (this._length / 10 / this._nbDoors) * PlanManager.getInstance().getZoomScale();
        var foundSize = Utils.getClosestNumberInArray(idealSize, JoineryNode.ImageSizeExtentions);
        //console.log(foundSize);
        if (foundSize === 0) {
            foundSize = JoineryNode.ImageSizeExtentions[0];
        }

        if (this._openingMode == SceneConstants.OpeningMode.mode_default) {
            for (var i = 0; i < this._nbDoors; ++i) {
                var sprite = new cc.Sprite();
                var spriteName = this._openingMode === SceneConstants.OpeningMode.mode_default ? 'plan/door' + foundSize + '.png' : 'plan/opening.png';
                if (this._isSelected) {
                    spriteName = this._openingMode === SceneConstants.OpeningMode.mode_default ? 'plan/door' + foundSize + '.png' : 'plan/openingSelected.png';
                } else if (this._isHovered) {
                    spriteName = this._openingMode === SceneConstants.OpeningMode.mode_default ? 'plan/door' + foundSize + '.png' : 'plan/openingHovered.png';
                }

                sprite.initWithSpriteFrameName(spriteName);
                sprite.setAnchorPoint(new cc.p(0.5, this._openingMode == SceneConstants.OpeningMode.mode_default ? 1 : 0.5));

                if (this.transparentDraw) {
                    sprite.setOpacity(64);
                }

                var scaleY = this._length / (sprite.width * 10 * this._nbDoors);
                sprite.setFlippedY(true);
                sprite.setFlippedX(true);

                var y = 0;
                y = this._thickness * 0.1;
                sprite.setPositionY(this.getY(10));

                if ((this._orientation === true && this._handleSide !== SceneConstants.HandleSide.handle_left) || (this._orientation === false && this._handleSide === SceneConstants.HandleSide.handle_left)) {
                    sprite.setPositionX(this._length * 0.005);
                } else {
                    sprite.setPositionX(-this._length * 0.005);
                }

                sprite.setScaleX((this._length - this._length * 0.1) / (sprite.width * 10 * this._nbDoors));
                sprite.setScaleY(scaleY);
                sprite.setName('door-' + i);
                if (this._openingSymetry === SceneConstants.Symetry.default && i % 2 !== 0) {
                    sprite.setFlippedX(false);
                }
                if (this._nbDoors < 2) {
                    if (this._handleSide !== SceneConstants.HandleSide.handle_left && !this._orientation
                        || this._handleSide === SceneConstants.HandleSide.handle_left && this._orientation) {
                        sprite.setFlippedX(true);
                    }
                    if (this._handleSide !== SceneConstants.HandleSide.handle_left && this._orientation
                        || this._handleSide === SceneConstants.HandleSide.handle_left && !this._orientation) {
                        sprite.setFlippedX(false);
                    }
                }
                this.addChild(sprite, 8);
            }
        }
    }

    getY(h: number): number | undefined{
        switch (this._wallInstallTye) {
            case 1:
                return -(this._thickness * 0.1) * 0.5;

            case 0:
                return (-h * 0.5);

            case -1:
                return ((this._thickness * 0.1) * 0.5 - 10);
        }
    }

    drawOverlap(joinery: Door, isValid: boolean) {
        var alpha = 255;
        if (this.transparentDraw) {
            alpha = 64;
        }

        this.clear();
        if (this._thickness > 0) {
            var h = (this._thickness * 0.1);
            var w = this._length / 10 - 1;
            var y = -h * 0.5;
            var x = -w * 0.5;
            var color: {border: any, plain:any} = {border: undefined, plain: undefined};
            if (isValid !== undefined) {
                color = this.getOverLapColor(isValid);
            } else {
                color = this.getOverLapColor(true);
            }
            var borderSize = 1;
            if (borderSize * PlanManager.getInstance().getZoomScale() < 1) {
                borderSize /= PlanManager.getInstance().getZoomScale();
            }

            var white = new cc.color(255, 255, 255, alpha);
            this.drawRect(new cc.p(x + borderSize * 0.5, y + borderSize * 0.5), new cc.p(x + w - borderSize * 0.5, y + h - borderSize * 0.5), white, borderSize, white);

            // Default door thickness
            h = (100 * 0.1);

            y = this.getY(h) as number;

            this.drawRect(new cc.p(x + borderSize * 0.5, y + borderSize * 0.5), new cc.p(x + w - borderSize * 0.5, y + h - borderSize * 0.5), color.plain, borderSize, color.border);

            var val2 = 0.043;
            var val1 = 0.015;

            if (this._handleSide === SceneConstants.HandleSide.handle_left && this._nbDoors === 1 && this._openingMode == SceneConstants.OpeningMode.mode_default) {
                val2 = 0.015;
                val1 = 0.043;
            } else if (this._nbDoors !== 1 || this._openingMode != SceneConstants.OpeningMode.mode_default) {
                val1 = 0.017;
                val2 = 0.017;
            }
            if (!this._orientation) {
                var tmp = val1;
                val1 = val2;
                val2 = tmp;
            }
            if ((this._orientation === true && this._handleSide !== SceneConstants.HandleSide.handle_left) || (this._orientation === false && this._handleSide === SceneConstants.HandleSide.handle_left)) {
                this.drawRect(new cc.p(x + w * 0.1, y - 0.5), new cc.p(x + w * 0.1 + w * 0.015, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));

            } else {
                this.drawRect(new cc.p(x + w - w * 0.1, y - 0.5), new cc.p(x + w - w * 0.1 - w * 0.015, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
            }
            this.drawRect(new cc.p(x - 0.5, y - 0.5), new cc.p(x + w * val1, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
            this.drawRect(new cc.p(x + w - w * val2, y - 0.5), new cc.p(x + w + 0.5, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
        }
    }
}